import React, { ReactNode } from 'react';

import styles from './Card.module.scss';

interface CardProps extends React.PropsWithChildren {
  title?: string;
  subtitle?: string;
  footer?: string | ReactNode;
}

export const Card: React.FC<CardProps> = ({ title, subtitle, children, footer }) => (
  <div className={styles['card-item']}>
    {title && <div className={styles['card-title']}>{title}</div>}
    <div className={styles['content']}>
      {subtitle && <div className={styles['subtitle']}>{subtitle}</div>}
      {children}
    </div>
    {footer && <div className={styles['footer']}>{footer}</div>}
  </div>
);
